import AppRoute from './AppRoute';
import Public from './Public';
import Auth from './Auth';

export default AppRoute;
export {
  Public,
  Auth
};
